import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const headers = getAuthHeaders().headers
export const findAll = async id => {
  try {
    const response = await tuApptoAPI.get(`/employees/findall/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const create = async request => {
  try {
    const response = await tuApptoAPI.post('/employees/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const update = async request => {
  try {
    const response = await tuApptoAPI.put('/employees/update', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const status = async request => {
  try {
    const response = await tuApptoAPI.put('/employees/status', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}
